// This file defines what a book report looks like and how to create a blank one.
// Think of it like a form template factory.

export const REPORT_FIELDS = [
  { id: "intro_hook",       section: "Introduction", label: "Sentence 1 — Hook",         hint: "Start with something that grabs the reader's interest about the book or theme." },
  { id: "intro_overview",   section: "Introduction", label: "Sentence 2 — Overview",     hint: "Introduce the title, the author, and a brief overview of the book." },
  { id: "intro_mainpoints", section: "Introduction", label: "Sentence 3 — Main Points",  hint: "State the three main points you will discuss (one per body paragraph)." },

  { id: "body1_topic",    section: "Body Paragraph 1", label: "Topic Sentence",      hint: "State your first main point — a theme, character, or setting." },
  { id: "body1_support1", section: "Body Paragraph 1", label: "Supporting Sentence 1", hint: "Give an example that supports your point. Include a brief quote or description." },
  { id: "body1_support2", section: "Body Paragraph 1", label: "Supporting Sentence 2", hint: "Give a second example." },
  { id: "body1_support3", section: "Body Paragraph 1", label: "Supporting Sentence 3", hint: "Give a third example." },

  { id: "body2_topic",    section: "Body Paragraph 2", label: "Topic Sentence",      hint: "State your second main point." },
  { id: "body2_support1", section: "Body Paragraph 2", label: "Supporting Sentence 1", hint: "Give an example that supports your point." },
  { id: "body2_support2", section: "Body Paragraph 2", label: "Supporting Sentence 2", hint: "Give a second example." },
  { id: "body2_support3", section: "Body Paragraph 2", label: "Supporting Sentence 3", hint: "Give a third example." },

  { id: "body3_topic",    section: "Body Paragraph 3", label: "Topic Sentence",      hint: "State your third main point." },
  { id: "body3_support1", section: "Body Paragraph 3", label: "Supporting Sentence 1", hint: "Give an example that supports your point." },
  { id: "body3_support2", section: "Body Paragraph 3", label: "Supporting Sentence 2", hint: "Give a second example." },
  { id: "body3_support3", section: "Body Paragraph 3", label: "Supporting Sentence 3", hint: "Give a third example." },

  { id: "conclusion_summary", section: "Conclusion", label: "Sentence 1 — Summary",  hint: "Briefly restate your main points from each body paragraph." },
  { id: "conclusion_message", section: "Conclusion", label: "Sentence 2 — Message",  hint: "Explain the overall message or theme you took away from the book and how it impacted you." },
  { id: "conclusion_impact",  section: "Conclusion", label: "Sentence 3 — Impact",   hint: "Explain why this book is an important message for others." },
];

// Function 1 — generates a short unique ID for each report
export function generateReportId() {
  return Math.random().toString(36).substring(2, 9);
}

// Function 2 — builds a brand new empty report object
// "title" is something like "Draft 1" or "Draft 2"
export function createBlankReport(title) {
  const fields = {};
  REPORT_FIELDS.forEach(f => {
    fields[f.id] = { value: "", lockedByParent: false, parentFeedback: "" };
  });

  return {
    id: generateReportId(),
    title,
    status: "inProgress",
    createdAt: new Date().toISOString(),
    fields,
  };
}